<template>
  <div>
    <my-header></my-header>
    <div class="content">
        <div class="ct-box">
            <h3 class="title">{{favoritesName}}<span class="font1">收藏夹详情</span></h3>
        </div>
        <water-fall
            v-show="listLength>0"
            :uId = "userId"
            :apiType="apiType"
            :isWaterfall="isWaterfall"
            :favoritesId="favoritesId"
            @getListLength="getListLength"
            :isPick="isPick"
        ></water-fall>
        <div class="df no-list" v-show="listLength==0">
            <img src="../../assets/img/home_default.png" alt="">
            <p>该收藏夹没有收藏作品<br />快去收藏有趣的作品吧~</p>
        </div>
    </div>
    <my-footer></my-footer>
    <warn ref="warn"></warn>
  </div>
</template>
<script>
import Warn from "../common/warn.vue"
import WaterFall from "../common/waterfall.vue" 
export default {
    data(){
        return {
            apiType: 2,
            isWaterfall: true,
            favoritesId: 0,
            favoritesName:"",
            listLength: 0,
            isPick:true,
            userId: 0,
        }
    },
    components: {
        Warn,
        WaterFall
    },
    created(){
        this.favoritesId = this.$route.params.favoritesId;
        this.favoritesName = this.$route.params.favoritesName;
        this.userId = this.$route.query.uid;
    },
    methods: {
        closeWarn(){
            this.$refs.warn.closeWarn();
        },
        getListLength(len){
            this.listLength = len;
        }
    }
}
</script>
<style scoped>
.content{
    min-height: 645px;
    padding: 50px 0;
    background-color: #f8f8f8;
}
.ct-box{
    max-width: 1280px;
    margin: 0 auto;
}
.ct-box>.title{
    font-size: 24px;
    padding-left: 30px;
    line-height: 80px;
    background-color: #fff;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    margin-bottom: 20px;
}
.font1{
    color: #999;
    font-size: 16px;
    margin-left: 1em;
}
.no-list{
    max-width: 1280px;
    margin: 0 auto;
    height: 560px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.no-list p{
    margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/collectDetail.vue